import admin from "../../const/admin";
import netcoServer from '../../apis/netcoServer';
import {UPDATE_TIMESTAMP_SERVER} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import modalDismiss from "../modal/modalDismiss";
import getTimestampsInfo from "../profile/getTimestampsInfo";
import loadingCall from "../helpers/loadingCall";

const updateTimestampServer= (formValues, callback) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/updateTimestampServer', formValues));
  handleResponse(dispatch, response, UPDATE_TIMESTAMP_SERVER, data => onSuccessPayload(data, getState), null, [getTimestampsInfo, modalDismiss], [callback]);
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', admin[getState().auth.language].timestampServerUpdated);
};
export default updateTimestampServer;